import { useEffect } from 'react';
import { useRouter } from 'next/router';

import SEO from '@/components/global/SEO';
import Layout from '@/components/global/Layout';
import Sidebar from '@/components/Pages/Apps/Sidebar';
import Form from '@/components/Pages/Rastreamento/Form';
import Provider from '@/components/Pages/Rastreamento/Provider';

import { PageWrapper } from '@/styles/Page';
import { PageContainer } from '@/styles/Pages/apps';

const Apps = (): JSX.Element => {
  const router = useRouter();

  useEffect(() => {
    router.prefetch('/rastreamento/resultado');
    router.prefetch('/rastreamento/encomendas');
  }, [router]);

  return (
    <>
      <Provider>
        <SEO
          title="Rastreamento"
          description="Aplicativo de rastreamento da Delps"
        />
        <Layout>
          <PageWrapper>
            <PageContainer>
              <Sidebar />
              <Form />
            </PageContainer>
          </PageWrapper>
        </Layout>
      </Provider>
    </>
  );
};

export default Apps;
